import Vue from 'vue'

export const replaceRidSecret = function (fullPath, ridSecret) {
	let query = {};
	if (fullPath.indexOf("?") !== -1) {
		let pathArr = fullPath.split("?")[1].split("&");
		pathArr.forEach(item => {
			var tempArr = item.split("=");
			var key = tempArr[0];
			var value = tempArr[1];
			query[key] = value;
		});
	}
	if (ridSecret) {
		query.ridSecret = ridSecret;
	}
	let path = "";
	for (const key in query) {
		const value = query[key];
		path = path + key + "=" + value + "&";
	}
	return "?" + path.substring(0, path.length - 1);
}

// export const objToParameter = function (data) {
//     let param = "";
//     for (let key in data) {
//       let value = data[key] === null ? "" : data[key];
//       param = param + key + "=" + value + "&";
//     }
//     param = param.substring(0, param.length - 1);
//     return param;
//   }  

//获取运行环境
export const getRunEnv = function () {
	var userAgent = navigator.userAgent.toLowerCase();
	var name = 'Unknown';
	var version = "Unknown";
	if (userAgent.indexOf("win") > -1) {
		name = "Windows";
		if (userAgent.indexOf("windows nt 5.0") > -1) {
			version = "Windows 2000";
		} else if (userAgent.indexOf("windows nt 5.1") > -1 || userAgent.indexOf("windows nt 5.2") > -1) {
			version = "Windows XP";
		} else if (userAgent.indexOf("windows nt 6.0") > -1) {
			version = "Windows Vista";
		} else if (userAgent.indexOf("windows nt 6.1") > -1 || userAgent.indexOf("windows 7") > -1) {
			version = "Windows 7";
		} else if (userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows 8") > -1) {
			version = "Windows 8";
		} else if (userAgent.indexOf("windows nt 6.3") > -1) {
			version = "Windows 8.1";
		} else if (userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows nt 10.0") > -1) {
			version = "Windows 10";
		} else {
			version = "Unknown";
		}
	} else if (userAgent.indexOf("iphone") > -1) {
		name = "Iphone";
	} else if (userAgent.indexOf("mac") > -1) {
		name = "Mac";
	} else if (userAgent.indexOf("x11") > -1 || userAgent.indexOf("unix") > -1 || userAgent.indexOf("sunname") > -1 || userAgent.indexOf("bsd") > -1) {
		name = "Unix";
	} else if (userAgent.indexOf("linux") > -1) {
		if (userAgent.indexOf("android") > -1) {
			name = "Android"
		} else {
			name = "Linux";
		}

	} else {
		name = "Unknown";
	}
	var os = new Object();
	os.name = name;
	os.version = version;

	return {
		os: os,
		browser: {}
	}
}

//校验手机号码
export const checkMobile = function (sMobile) {
	if ( !sMobile || sMobile.length < 11 ) {
		return false;
	}
	if (!(/^1[3|4|5|8][0-9]\d{4,8}$/.test(sMobile))) {
		return false;
	} else {
		return true;
	}
}

//裁切
export const cutFitWidthImg = function (value, split) {
	if (!value) return ''
	value = value.toString()
	if (value.indexOf('.aliyuncs.com') == -1 && value.indexOf('fimage.huaxiyou.cc') == -1) return value;
	if (!!split) {
		if (typeof split === 'number') {
			let width = parseInt(document.body.clientWidth / split)
			return value += '@' + width + 'w.gif'
		}
		else {
			return value += '@' + split + '.gif'
		}
	}
	else {
		return value += '@' + parseInt(document.body.clientWidth) + 'w.gif'
	}
}

//文件下载
export const downloadFile = function (sUrl) {	

	//iOS devices do not support downloading. We have to inform user about this.
	if (/(iP)/g.test(navigator.userAgent)) {
			alert('Your device does not support files downloading. Please try again in desktop browser.');
			return false;
	}

	var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
	var isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;

	//If in Chrome or Safari - download via virtual link click
	if (isChrome || isSafari) {
			//Creating new link node.
			var link = document.createElement('a');
			link.href = sUrl;

			if (link.download !== undefined) {
					//Set HTML5 download attribute. This will prevent file from opening if supported.
					var fileName = sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length);
					link.download = fileName;
			}

			//Dispatching click event.
			if (document.createEvent) {
					var e = document.createEvent('MouseEvents');
					e.initEvent('click', true, true);
					link.dispatchEvent(e);
					return true;
			}
	}

	// Force file download (whether supported by server).
	if (sUrl.indexOf('?') === -1) {
			sUrl += '?download';
	}

	window.open(sUrl, '_self');
	return true;
}


Vue.filter('cutFitWidthImg', cutFitWidthImg)

Vue.filter('autoOrientFitWidthImg', function (value, split) {
	if (!value) return ''
	value = value.toString()
if (value.indexOf('.aliyuncs.com') == -1 && value.indexOf('fimage.huaxiyou.cc') == -1) return value;
if (!!split) {
	if (typeof split === 'number') {
		let width = parseInt(document.body.clientWidth / split)
			return value += '?x-oss-process=image/resize,w_' + width + '/auto-orient,1'
	}
	else {
		//split : w_300
		return value += '?x-oss-process=image/resize,' + split + '/auto-orient,1'
	}
}
else {
	return value += '?x-oss-process=image/resize,w_' + parseInt(document.body.clientWidth) + '/auto-orient,1'
}
})